import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-up",
  "use": "chevron-up-usage",
  "viewBox": "0 0 500 501",
  "content": "<symbol viewBox=\"0 0 500 501\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"chevron-up\">\n<path d=\"M48.5438 365.66C43.1627 371.019 34.4326 371.024 29.0446 365.672C23.6567 360.321 23.6511 351.639 29.0323 346.28L240.181 136.022C245.565 130.66 254.303 130.659 259.689 136.019L470.965 346.277C476.348 351.634 476.345 360.316 470.958 365.67C465.572 371.023 456.842 371.02 451.459 365.663L249.939 165.114L48.5438 365.66Z\" fill=\"#222222\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol